import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { checkOrgSuccess, checkOrgFailed } from '../actions';
import { OrganizationTypes } from '../types';

const { API_BASE_URL } = urls || {};

export function* checkOrgExistence({ data: { id, cb } }) {
  const url = `${API_BASE_URL}/portals/${encodeURIComponent(id)}/organisation`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success && response.statusCode === 200) {
    const org = response.raw || {};
    const payload = {
      id: org.id,
      portalAlias: org.portalAlias || org.id,
      name: org.name,
      logoUrl: org.logoUrl,
      courseAlias: org.courseAlias,
    };
    yield put(checkOrgSuccess(payload));
    if (cb) {
      cb(payload);
    }
    return;
  }
  if (response.statusCode === 404) yield put(checkOrgFailed());
}

export function* orgCheck() {
  yield takeEvery(OrganizationTypes.CHECK_ORG_EXISTS, checkOrgExistence);
}
